<template>
  <aside class="sidebar" :class="{ open: isOpen }">
    <div class="sidebar-header">
      <span class="brand">El Shaday</span>
      <span class="subtitle">Inscrições</span>
    </div>

    <nav class="sidebar-nav">
      <router-link to="/admin" class="nav-item" exact-active-class="active">
        <Icon name="dashboard" />
        <span>Dashboard</span>
      </router-link>
      <router-link to="/admin/eventos" class="nav-item" active-class="active">
        <Icon name="event" />
        <span>Eventos</span>
      </router-link>
      <router-link to="/admin/inscricoes" class="nav-item" active-class="active">
        <Icon name="list" />
        <span>Inscrições</span>
      </router-link>
      <router-link v-if="canShowCheckin" to="/admin/checkin" class="nav-item" active-class="active">
        <Icon name="checkin" />
        <span>Check-in</span>
      </router-link>
      <router-link v-if="canSeeCobrancas" to="/admin/cobrancas" class="nav-item" active-class="active">
        <Icon name="list" />
        <span>Cobranças</span>
      </router-link>
      <router-link v-if="canManageRepasses" to="/admin/repasses" class="nav-item" active-class="active">
        <Icon name="money" />
        <span>Repasses</span>
      </router-link>
      <router-link v-if="canSeeSaques" to="/admin/saques" class="nav-item" active-class="active">
        <Icon name="money" />
        <span>Saques</span>
      </router-link>
      <router-link v-if="canManageAdmins" to="/admin/usuarios" class="nav-item" active-class="active">
        <Icon name="users" />
        <span>Usuários</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <div class="user-info">
        <span class="user-name">{{ adminName }}</span>
        <span v-if="roleBadge" class="role-badge" :class="`role-${roleBadge.cls}`">{{ roleBadge.label }}</span>
      </div>
      <button class="logout-btn" @click="$emit('logout')">Sair</button>
    </div>
  </aside>
</template>

<script>
const Icon = {
  props: ['name'],
  template: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path v-if="name === 'dashboard'" d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor"/>
    <path v-else-if="name === 'event'" d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z" fill="currentColor"/>
    <path v-else-if="name === 'list'" d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" fill="currentColor"/>
    <path v-else-if="name === 'users'" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor"/>
    <path v-else-if="name === 'money'" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="currentColor"/>
    <path v-else-if="name === 'checkin'" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
  </svg>`
}

export default {
  name: 'SidebarNav',
  components: { Icon },
  props: {
    isOpen: { type: Boolean, default: false },
    adminName: { type: String, default: '' },
    role: { type: String, default: null },
    canManageAdmins: { type: Boolean, default: false },
    canManageRepasses: { type: Boolean, default: false },
    canSeeSaques: { type: Boolean, default: false },
    canSeeCobrancas: { type: Boolean, default: false },
    canShowCheckin: { type: Boolean, default: false }
  },
  emits: ['logout'],
  computed: {
    roleBadge() {
      if (this.role === 'ADMIN') return { label: 'Admin', cls: 'admin' }
      if (this.role === 'CHECKIN') return { label: 'Voluntario', cls: 'checkin' }
      if (this.role === 'ORGANIZADOR') return { label: 'Organizador', cls: 'organizador' }
      return null
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 240px; height: 100vh;
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  display: flex; flex-direction: column;
  position: fixed; left: 0; top: 0;
  z-index: 50;
  transition: transform 0.25s ease-in-out;
  border-right: 1px solid var(--color-bg-separator);
}
.sidebar-header {
  padding: var(--spacing-lg) var(--spacing-base);
  border-bottom: 1px solid var(--color-bg-separator);
  display: flex; flex-direction: column;
}
.brand { font-size: var(--text-lg); font-weight: 800; color: var(--color-accent); }
.subtitle { font-size: 11px; color: var(--color-text-muted); letter-spacing: 1px; text-transform: uppercase; }
.sidebar-nav { flex: 1; padding: var(--spacing-md) 0; }
.nav-item {
  display: flex; align-items: center; gap: var(--spacing-md);
  padding: 10px var(--spacing-base);
  color: var(--color-text-secondary); text-decoration: none;
  font-size: var(--text-sm); font-weight: 500;
  border-left: 3px solid transparent;
  transition: var(--transition-default);
}
.nav-item:hover { background: var(--color-bg-hover); color: var(--color-text-primary); }
.nav-item.active {
  background: rgba(37, 99, 235, 0.08);
  color: var(--color-accent);
  border-left-color: var(--color-accent);
  font-weight: 600;
}
.sidebar-footer {
  padding: var(--spacing-base);
  border-top: 1px solid var(--color-bg-separator);
  display: flex; flex-direction: column; gap: var(--spacing-sm);
}
.user-info { display: flex; flex-direction: column; gap: 4px; }
.user-name { font-size: var(--text-sm); font-weight: 600; }
.role-badge {
  align-self: flex-start;
  font-size: 10px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase;
  padding: 2px 6px; border-radius: 3px;
}
.role-admin { background: rgba(37,99,235,0.1); color: var(--color-accent); }
.role-checkin { background: var(--color-bg-body); color: var(--color-text-secondary); }
.role-organizador { background: #ede9fe; color: #6d28d9; }
.logout-btn {
  background: none; border: none; color: var(--color-text-muted);
  font-size: var(--text-sm); cursor: pointer; padding: 4px 0;
  text-align: left;
}
.logout-btn:hover { color: var(--color-danger); }

@media (max-width: 900px) {
  .sidebar { transform: translateX(-100%); }
  .sidebar.open { transform: translateX(0); }
}
</style>
